import { extendTheme } from '@chakra-ui/react';
import colors from './colors';

// 본 앱(laeebly-front)의 theme 과 같은 폰트·전역 스타일을 사용한다.
const theme = extendTheme({
  fonts: {
    heading: `'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`,
    body: `'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`,
    mono: `source-code-pro, Menlo, Monaco, Consolas, monospace`,
  },
  colors,
  styles: {
    global: {
      'html, body': {
        wordBreak: 'keep-all',
        overflowWrap: 'break-word',
        bg: 'neutral.50',
        color: 'neutral.800',
        letterSpacing: '-0.01em',
      },
      '*::selection': { bg: 'brand.100' },
    },
  },
  components: {
    Badge: {
      variants: {
        brand: { bg: 'brand.50', color: 'brand.700', borderRadius: '4px', fontWeight: '600', px: 2, py: 0.5, fontSize: 'xs' },
        neutral: { bg: 'neutral.100', color: 'neutral.700', borderRadius: '4px', fontWeight: '500', px: 2, py: 0.5, fontSize: 'xs' },
        warning: { bg: 'accent.50', color: 'accent.700', borderRadius: '4px', fontWeight: '600', px: 2, py: 0.5, fontSize: 'xs' },
      },
    },
  },
});

export default theme;
